import {useChatStateValue} from '../utils/CopilotChatContext'

/**
 * Hook to get organizations that require SSO authentication.
 * @returns A tuple containing:
 *   - Boolean indicating if SSO authentication is needed
 *   - Array of organization login names requiring SSO auth
 */
export function useSSOOrgNames(): {needsSsoAuthentication: boolean; ssoOrgNames: string[]} {
  const missingOrgIds = useChatStateValue('messagesLoading')?.missingOrgIds
  const ssoOrganizations = useChatStateValue('ssoOrganizations')
  const ssoOrgNames = missingOrgIds
    ?.map(id => {
      const organization = ssoOrganizations?.find(org => org.id === String(id))
      return organization?.login
    })
    ?.filter((login: string | undefined): login is string => !!login)
  const needsSsoAuthentication = Boolean(missingOrgIds && missingOrgIds.length > 0)

  return {needsSsoAuthentication, ssoOrgNames: ssoOrgNames || []}
}
